// extracted by mini-css-extract-plugin
export default {"container-table":"styles_container-table__KHJde","type_column":"styles_type_column__WvSiA","delete_btn":"styles_delete_btn__uszb4","delete_icon":"styles_delete_icon__GfBMK"};